module.exports = __webpack_public_path__ + "img/icon-chat.ce071377.svg";